// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__cGOse","left":"StickyBox_left__3ksPL","right":"StickyBox_right__3R6Gh"};